import { getConversationById } from '@app/helpers'

import { getUpdateAt } from '@lib/utils'

import { ChatState, SetSuggestedActionStatusPayload } from '../types'

export const onSetSuggestedActionStatus = (
  state: ChatState,
  payload: SetSuggestedActionStatusPayload
): ChatState => {
  const { conversationId, suggestedActionId, status } = payload

  const conversation = getConversationById(state.conversations, conversationId)
  if (!conversation) {
    return state
  }

  const updateDate = getUpdateAt()

  const suggestedActions = conversation.suggestedActions?.map((action) =>
    action.id === suggestedActionId ? { ...action, status, updateDate } : action
  )

  return {
    ...state,
    conversations: {
      ...state.conversations,
      [conversationId]: {
        ...conversation,
        suggestedActions,
        updateDate,
      },
    },
  }
}
